import { nanoid } from 'nanoid';

// Shrinks a picked photo so its longest side is at most `maxSide` px and re-encodes it as JPEG.
// Drawing a full-size iPhone photo (24/48 MP) onto a canvas fails silently on older iOS
// (canvas area limit 4096x4096), so the photo is scaled down while it is drawn.
export const resizeImageFile = (file, maxSide = 1600) => new Promise((resolve, reject) => {
    const srcUrl = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
        URL.revokeObjectURL(srcUrl);
        const scale = Math.min(1, maxSide / Math.max(img.naturalWidth, img.naturalHeight));
        const canvas = document.createElement('canvas');
        canvas.width = Math.round(img.naturalWidth * scale);
        canvas.height = Math.round(img.naturalHeight * scale);
        canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
        canvas.toBlob((blob) => {
            if (!blob) return reject(new Error('Could not encode image'));
            resolve({
                id: nanoid(),
                imgUrl: canvas.toDataURL('image/jpeg', 0.85),
                binary: new File([blob], `${nanoid()}.jpg`, { type: 'image/jpeg' }),
                selected: false,
                value: ''
            });
        }, 'image/jpeg', 0.85);
    };
    img.onerror = () => {
        URL.revokeObjectURL(srcUrl);
        reject(new Error('Could not read image'));
    };
    img.src = srcUrl;
});
